<template>
  <view class="pft-t-body">
    <template v-for="(row, rowIndex) in rowItems" :key="row.rowIndex">
      <Summary v-if="row.type === 'sum'" :row="row" />
      <template v-else>
        <CompareRowItem v-if="isCompare" :row="row" :compareRow="compareRow(row)" :rowIndex="rowIndex" :columns="columns" />
        <RowItem v-else :row="row" :rowIndex="rowIndex" :columns="columns" />
      </template>
    </template>
    <Summary v-if="sumConfig?.length && !sumWithScroll" />
  </view>
</template>

<script lang="ts" setup>
import { computed, inject, provide, ref, watch, nextTick, onUnmounted } from "vue"
import { defaultsDeep, isEqual } from "lodash-es"
import RowItem from "../components/rowItem.vue"
import CompareRowItem from "../components/compareRowItem.vue"
import Summary from "../components/summary.vue"
import { hideClass, showClass } from "../fade.hook"
const props = defineProps<{
  columns: any[]
  isCompare?: boolean
  separated: boolean
  rows: number
  data: any[]
  duration: number
}>()

provide("rows", props.rows)

const list = ref<{ [key: string]: string | number }[]>([])

const rowItems = ref<{ [key: string]: string | number }[]>([])

// const tableBodyStyle = computed(() => {
//   return {
//     ...style,
//     // "grid-column-start": 1,
//     // "grid-column-end": columns.value.length + 1,
//     // "grid-template-columns": columns.value.map(column => column.width || "1fr").join(" "),
//     "grid-template-rows": `repeat(${countShowRows.value - 1}, var(--MAX-ROW-ALL-HEIGHT, 32px))`,
//   }
// })
const sumConfig = inject("sumConfig") as any[]
const sumWithScroll = inject("sumWithScroll") as boolean
const getCompareRow = inject("getCompareRow") as (row: any) => any

const rowHeight = ref(32)

const itemClass = (num: number, rank: number) => {
  const classObj = {
    "align-left": props.columns[num].align === "left",
    "align-right": props.columns[num].align === "right",
    dot: props.columns[num].listStyle === "dot",
    "separated-row": props.separated && rank % 2 === 0,
  }
  return classObj
}

provide("itemClass", itemClass)

const compareRow = (row: any) => {
  return getCompareRow(row)
}
const itemStyle = (num: number, rowIndex: number) => {
  let defaultVal: any = {
    color: "#a3a6ad",
    height: "32px",
  }
  let style = props.columns[num].style
  if (style instanceof Function) {
    const dataItem = rowItems[rowIndex]
    style = style(dataItem)
  }
  const newStyle = defaultsDeep({}, style, defaultVal)
  // console.log("newStyle", rowIndex, props.rows, newStyle)
  if (rowIndex === props.rows) {
    newStyle.height = "0px"
  }
  if (newStyle.height) {
    newStyle.lineHeight = newStyle.height
    rowHeight.value = Number(newStyle.height.replace("px", ""))
  }
  return newStyle
}

provide("itemStyle", itemStyle)

let timer: ReturnType<typeof setTimeout> | undefined = undefined

watch(
  () => props.data,
  (datas: any) => {
    // 创建新的处理后数据
    const newProcessedData = datas.map((item, index) => {
      return { ...item, rank: index + 1 }
    })
    // 判断新数据是否与当前list.value完全一致
    const currentData = list.value.map(item => ({ ...item }))
    const isDataEqual = isEqual(newProcessedData, currentData)
    // 如果数据完全一致，不进行后续处理
    if (isDataEqual) {
      return
    }
    // 数据不一致，更新list.value
    list.value = newProcessedData
    const items = list.value.slice(0, props.rows + 1)
    rowItems.value = items
    timer && clearInterval(timer)
    if (list.value.length > props.rows) {
      timer = setInterval(() => {
        hideClass.value = { "fadding-out": true }
        showClass.value = { "fadding-in": true }
        const first = list.value.shift()
        if (first) list.value.push(first)
        setTimeout(() => {
          const items = list.value.slice(0, props.rows + 1)
          rowItems.value = items
          nextTick(() => {
            hideClass.value = {}
            showClass.value = {}
          })
        }, 900)
      }, props.duration * 1000)
    }
  },
  { immediate: true, deep: true },
)

onUnmounted(() => {
  timer && clearInterval(timer)
  //console.log("tableRef", tableRef.value)
})
</script>

<style lang="scss" scoped></style>
